import React, { Component } from 'react'
import './PoliticalParty.css'

export default class PoliticalParty extends Component {
    render() {
        return (
            <div className="PoliticalParty col text-center">
                <img src={this.props.icon} className="img-fluid" alt={this.props.name} />
                <h4>
                    { this.props.name }
                </h4>
                <p>
                    {this.props.manifesto}
                </p>
                <button 
                    onClick= { () => { this.props.onClick( this.props.id ) } }
                    className="btn btn-primary"
                >
                    <i className="fas fa-check"></i> Vote!
                </button>
            </div>
        )
    }
}
